/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Relativeyearagomany3Inputs */

const en_relativeyearagomany3 = /** @type {(inputs: Relativeyearagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} years ago`)
};

const pt_relativeyearagomany3 = /** @type {(inputs: Relativeyearagomany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.n} anos`)
};

/**
* | output |
* | --- |
* | "{n} years ago" |
*
* @param {Relativeyearagomany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativeyearagomany3 = /** @type {((inputs: Relativeyearagomany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativeyearagomany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativeyearagomany3(inputs)
	return pt_relativeyearagomany3(inputs)
});
export { relativeyearagomany3 as "relativeYearAgoMany" }